import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { TagsComponent } from '@app/layout/tags/tags.component';
import { LoadPopularSearchRequests, MainpageSelectors } from '@app/store';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-popular-search-requests',
  templateUrl: './popular-search-requests.component.html',
  styleUrls: ['./popular-search-requests.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TagsComponent],
})
export class PopularSearchRequestsComponent implements OnInit {
  constructor(private store: Store) {}

  requests$: Observable<string[] | undefined> = this.store.select(
    MainpageSelectors.popularSearchRequests,
  );

  ngOnInit(): void {
    this.store.dispatch(new LoadPopularSearchRequests());
  }
}
